import { inject, Injectable } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';
import { AddModerator, GetModerators, SetModeratorSearch, UpdateModerator } from './moderator.actions';
import { ModeratorService } from '@tsin-core/services/http/moderator.service';
import { IModerator } from './moderator.models';
import { LoadingState } from '@tsin-core/entities';
import { catchError, tap } from 'rxjs';
import { UserRoleEnum } from '@tsin-shared/enums/UserRoleEnum';

export class ModeratorStateModel {
  public searchQuery!: String;
  public moderators!: IModerator[];
  public selectedModerator!: IModerator | null;
  public loading!: LoadingState;
}

const defaults = {
  searchQuery: '',
  moderators: [],
  selectedModerator: null,
  loading: LoadingState.notLoading,
};

@State<ModeratorStateModel>({
  name: 'moderatorState',
  defaults
})

@Injectable()
export class ModeratorState {
  moderatorService: ModeratorService = inject(ModeratorService);

  @Selector()
  static getModerators(state: ModeratorStateModel) {
    return state.moderators;
  }

  @Selector()
  static getLoading(state: ModeratorStateModel) {
    return state.loading;
  }

  @Action(GetModerators)
  getModerators({ patchState }: StateContext<ModeratorStateModel>, action: GetModerators) {
    patchState({ loading: LoadingState.loadingList });
    return this.moderatorService.getModerators().pipe(
      tap((moderators: IModerator[]) => {
        // console.log(moderators);
        const filteredModerators = moderators.filter((moderator: IModerator) => moderator.role.toLowerCase() === UserRoleEnum.PRO_MODERATOR.toLowerCase());
        patchState({ moderators: filteredModerators, loading: LoadingState.notLoading });
        // console.log(filteredModerators);
      }),
      catchError((error) => {
        patchState({ loading: LoadingState.notLoading });
        throw error;
      })
    );
  }

  @Action(AddModerator)
  addModerator(ctx: StateContext<ModeratorStateModel>, action: AddModerator) {
    ctx.patchState({ loading: LoadingState.loadingAddUpdate });
    return this.moderatorService.createModerator(action.payload).pipe(
      tap((result: IModerator) => {
        // console.log('Create Moderator >>', result);
        const state = ctx.getState();
        ctx.patchState({
          moderators: [...state.moderators, result],
          loading: LoadingState.notLoading
        });
      }),
      catchError((error) => {
        ctx.patchState({ loading: LoadingState.notLoading });
        return error;
      })
    );
  }


  @Action(UpdateModerator)
  updateModerator(ctx: StateContext<ModeratorStateModel>, action: UpdateModerator) {
    ctx.patchState({ loading: LoadingState.loadingAddUpdate });
    return this.moderatorService.updateModerator(action.payload).pipe(
      tap((result: IModerator) => {
        let moderators = ctx.getState().moderators;
        const index = moderators.findIndex((moderator: IModerator) => moderator.id === result.id);
        moderators[index] = result;
        ctx.patchState({
          moderators,
          loading: LoadingState.notLoading
        });
      }),
      catchError((error) => {
        ctx.patchState({ loading: LoadingState.notLoading });
        return error;
      })
    );
  }

  // Action to set the search query
  @Action(SetModeratorSearch)
  setSearchQuery(ctx: StateContext<ModeratorStateModel>, action: SetModeratorSearch) {
    ctx.patchState({ loading: LoadingState.loadingList });
    setTimeout(() => {
      ctx.patchState({
        searchQuery: action.query,
        loading: LoadingState.notLoading
      });
    }, 1000)
  }


}
